/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState,
  useContext,
  useEffect,
  Fragment,
  useRef,
} from 'react';
import { mapValues, cloneDeep, some } from 'lodash';
import moment from 'moment-timezone';
import { FormHelperText, Typography } from '@material-ui/core';
import {
  Loader,
  ReactDatePicker,
  ScrollToTarget,
} from '@mummssoftware/common-ui';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { CPPGlobalContext } from '@mummssoftware/global-context/CPPGlobalContext';
import {
  formatPostDate,
  formatDateYYYYMMDD,
} from '@mummssoftware/utils/formatters';
import { Submitted, Autosave, Discard } from '@mummssoftware/utils/constants';
import { getInputEngine } from '@mummssoftware/utils/utils';
import { checkSubqchoices } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { ReadOnlyForm } from './ReadOnlyForm';
import { PreviewForm } from './PreviewForm';
import { Context } from '../../context';
import { CPPContext } from '../Context/CPPContext';
import {
  SET_CPP,
  SUBMIT_PLAN,
  SET_SUBMIT_PLAN_ACTIVE,
  DISCARD_EDIT,
  RESET_DISCARD_EDIT,
  SET_PREVIEW_MODE,
  SET_CPP_TASKS,
  Editing,
  EditFullMode,
} from '../Context/constants';
import {
  FormBody,
  ElementDiv,
  StyledUl,
  FormLi,
  FullWidthLi,
  EffDateDiv,
  PreviewFormDiv,
  PreviewFormTop,
  SavingDiv,
} from './WrapperDiv';
import {
  FormProps,
  horizontal,
  label,
  input,
  radio,
  singleselect,
  multiselect,
  Other,
  Bereavement,
  TreatmentSchedule,
  AdditionalAssistance,
} from './constants';
import {
  LabelField,
  InputField,
  CheckBoxField,
  SelectField,
  MultiSelectField,
  RadioField,
  DCButton,
  CPPTitleInputField,
} from './Field';
import {
  updateElementBis,
  updateFalseNodes,
  createEditInitSubmitState,
  createGolbalEditInitState,
  createGlobalInitIds,
  unselectElement,
  unselectId,
  getRadioParent,
  createInitState,
  createInitSubmitState,
  cleanSubmittedState,
  cleanSubmittedStateforDC,
  updateDCElement,
  updateChildDCNodes,
  createGolbalDCInitState,
  getOtherOption,
  createPreviewState,
  reinstateForm,
  createPreviewDCState,
  createDCState,
  createFormData,
} from './utils';
import { useStyles } from './style';
import defaults from '../../translations/en.json';

export const FormRenderer = React.memo(({ formData }: FormProps) => {
  const {
    patient,
    currentUser,
    savedCarePlanProblem,
    planCache,
    savePatientCarePlanProblem,
    updateCarePlanProblemCache,
    setErrorInfo,
    siteId,
  } = useContext(Context);
  const { discardEdit, submitPlan, submitPlanActive, dispatch } = useContext(
    CPPContext,
  );
  const { cppNotesGlobal } = useContext(CPPGlobalContext);
  const { appVisit, patientDateRestrictions } = useContext(GlobalContext);
  const basicDateConstraint: Date | undefined = moment.isMoment(
    patientDateRestrictions?.basicDateConstraint,
  )
    ? patientDateRestrictions?.basicDateConstraint.toDate()
    : patientDateRestrictions?.basicDateConstraint;

  const classes = useStyles();

  const isBereavementPlan = formData.careplanproblemshortname === Bereavement;
  const isOtherPlan = formData.careplanproblemshortname === Other;
  const isAddAssistancePlan =
    formData.careplanproblemshortname === AdditionalAssistance;
  const isTreatmentPlan =
    formData.careplanproblemshortname === TreatmentSchedule;

  const isNameEditablePlan =
    isOtherPlan || isTreatmentPlan || isBereavementPlan;

  const isPlanTitleEditable =
    isNameEditablePlan && !formData.userprovideddisplayname;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isSubmittingRef = useRef(false);
  const [previewSubmitDisabled, setPreviewSubmitDisabled] = useState(false);

  const resetSubmitInProgress = () => {
    isSubmittingRef.current = false;
    setPreviewSubmitDisabled(false);
  };
  // EFFECTIVE date picker
  const [effDate, setEffDate] = useState<Date | number | null>(
    formData.effectivedate ? moment(formData.effectivedate).toDate() : null,
  );
  // INTERVENTION date picker
  const [intDate, setIntDate] = useState<Date | number | null>(null);
  // Preview Data
  const [previewData, setPreviewData] = useState<any>(null);
  // submit Form dispatched from Widget Header
  useEffect(() => {
    if (submitPlan) {
      onSubmit();
    }
  }, [submitPlan]);

  // on load reset
  useEffect(() => {
    dispatch({
      type: RESET_DISCARD_EDIT,
      payload: false,
    });
    dispatch({
      type: SET_PREVIEW_MODE,
      payload: false,
    });
  }, []);

  const [updatedData, setUpdatedData] = useState<any>(null);

  // on initial load updatedData
  useEffect(() => {
    const parsedFormData = createFormData(formData);
    if (parsedFormData) {
      setUpdatedData(parsedFormData);
    }
  }, []);

  const [initIds, setInitIds] = useState<any>(null);
  const [initGroupBoxState, setInitGroupBoxState] = useState<any>(null);
  const [initSubmitGroupBoxState, setInitSubmitGroupBoxState] = useState<any>(
    null,
  );
  const [initDCGroupBoxState, setInitDCGroupBoxState] = useState<any>(null);
  const [isEditdata, setIsEditDate] = useState<boolean>(false);

  const isValid = updatedData && Array.isArray(updatedData);

  // todo add formData?.id and remove all uneceassary state updates
  useEffect(() => {
    if (isValid) {
      const initids = createGlobalInitIds(updatedData);
      initids && setInitIds(initids);
      // first we do the initFirstGroupBoxState = EDITING groupBoxState
      // if groupBoxState is {} then this means this is a NEW form
      const initFirstGroupBoxState = createGolbalEditInitState(updatedData);
      const isEditData = !!Object.keys(initFirstGroupBoxState).length;
      isEditData && setIsEditDate(isEditData);
      const initgroupBoxState = isEditData
        ? initFirstGroupBoxState
        : createInitState(updatedData);
      initgroupBoxState && setInitGroupBoxState(initgroupBoxState);
      const initsubmitGroupBoxState = isEditData
        ? createEditInitSubmitState(initgroupBoxState)
        : createInitSubmitState(updatedData);
      initsubmitGroupBoxState &&
        setInitSubmitGroupBoxState(initsubmitGroupBoxState);

      const initdcGroupBoxState = isEditData
        ? createGolbalDCInitState(updatedData)
        : {};
      initdcGroupBoxState && setInitDCGroupBoxState(initdcGroupBoxState);
    }
  }, [updatedData]);

  const [groupBoxState, setGroupBoxState] = useState<any>(
    cloneDeep(initGroupBoxState),
  );
  const [submitGroupBoxState, setSubmitGroupBoxState] = useState<any>(
    initSubmitGroupBoxState,
  );
  const [selectedIds, setSelectedIds] = useState<any>(initIds);
  const [dcGroupBoxState, setDCGroupBoxState] = useState<any>(
    initDCGroupBoxState,
  );
  const [submitButtonState, setSubmitButtonState] = useState<any>({});

  const isPlanValid =
    isValid && groupBoxState && submitGroupBoxState && dcGroupBoxState;

  /**
   * SET INIT STATES
   */
  useEffect(() => {
    if (initGroupBoxState) {
      setGroupBoxState(cloneDeep(initGroupBoxState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initGroupBoxState && Object.keys(initGroupBoxState)[0]]);

  useEffect(() => {
    if (initSubmitGroupBoxState) {
      setSubmitGroupBoxState(initSubmitGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initSubmitGroupBoxState && Object.keys(initSubmitGroupBoxState)[0]]);

  useEffect(() => {
    if (initIds) {
      setSelectedIds(initIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initIds && Object.keys(initIds)[0]]);

  useEffect(() => {
    if (initDCGroupBoxState) {
      setDCGroupBoxState(initDCGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initDCGroupBoxState && Object.keys(initDCGroupBoxState)[0]]);

  useEffect(() => {
    // reset all the states if change of care plan
    if (initIds) {
      setSelectedIds(initIds);
    }
    if (initSubmitGroupBoxState) {
      setSubmitGroupBoxState(initSubmitGroupBoxState);
    }
    if (initGroupBoxState) {
      setGroupBoxState(cloneDeep(initGroupBoxState));
    }
    if (initDCGroupBoxState) {
      setDCGroupBoxState(initDCGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.id]);

  // helpful do not remove
  // console.log('***updatedData***', updatedData);
  // console.log('*initGroupBoxState*', initGroupBoxState);
  // console.log('*groupBoxState*', groupBoxState);
  // console.log('**dcGroupBoxState**', dcGroupBoxState);
  // console.log('***submitGroupBoxState***', submitGroupBoxState);
  // console.log('***submitButtonState***', Object.values(submitButtonState));
  // console.log('***selectedIds***', selectedIds);

  const [cppTitle, setCppTitle] = useState<string | null>(null);
  const isOtherPlanNoTitle = isPlanTitleEditable && !cppTitle;

  const handleTitleChange = (event: any) => {
    setCppTitle(event.target.value);
    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: true,
    });
  };

  // ******************************************************
  // @note VISIT if a visit is being recorded save date and id
  const patientvisitId = appVisit ? appVisit.id : null;
  const visitdatetime = appVisit ? appVisit.effectivedatetime : null;

  const {
    careplanproblemdescription,
    careplanproblemname,
    careplanproblemshortname,
    numtasks,
    id,
  } = formData;

  const planId = isEditdata ? id : planCache ? planCache.id : '';
  const displayName = isBereavementPlan
    ? `${Bereavement} - ${cppTitle}`
    : cppTitle;

  const interventionstartdate = intDate ? formatDateYYYYMMDD(intDate) : null;

  const patientCareplanProblemDTO = {
    careplanproblemdescription,
    careplanproblemname,
    careplanproblemshortname,
    createdatetime: formatPostDate(Date.now()),
    effectivedate: formatDateYYYYMMDD(effDate as any),
    interventionstartdate,
    createpersonid: formData.createpersonid || currentUser.userId,
    modifiedpersonid: currentUser.userId,
    siteid: siteId || patient.siteId.toString(),
    patientnumber: patient.patientNumber,
    id: planId,
    patientvisit_id: patientvisitId,
    visitdatetime,
    numtasks,
    userprovideddisplayname: formData.userprovideddisplayname || displayName,
  };
  // ******************************************************

  // plan can only be DC if the plan has already been submitted
  // if in Progress or not yet submitted, you can toggle the checkbox
  const isPlanDCable =
    formData && formData.status && formData.status === Submitted;

  const hasAnswers = (x: any) =>
    x === true || x === false || typeof x === 'string';

  useEffect(() => {
    // if any CheckBox is true then SUBMIT BUTTON active
    if (some(Object.values(submitButtonState), (x) => hasAnswers(x))) {
      // no need to dispatch for every change
      !submitPlanActive &&
        dispatch({
          type: SET_SUBMIT_PLAN_ACTIVE,
          payload: true,
        });
    } else {
      dispatch({
        type: SET_SUBMIT_PLAN_ACTIVE,
        payload: false,
      });
    }
  }, [JSON.stringify(Object.values(submitButtonState))]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const isSubmittable =
      submitGroupBoxState && Object.keys(submitGroupBoxState).length;
    if (submitPlanActive && isSubmittable) {
      const formsubmission = getPlanData();
      if (formsubmission) {
        const submissionForm: mumms.patientCareplanProblemDTO = {
          ...patientCareplanProblemDTO,
          formsubmissionautosave: formsubmission,
          status: Autosave,
        };
        const interval = setInterval(() => {
          saveFormCache(submissionForm);
        }, 60000);

        if (discardEdit || submitPlan) {
          clearInterval(interval);
        }
        return () => clearInterval(interval);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitPlan, submitPlanActive, planCache, discardEdit]);

  const saveFormCache = (subForm: mumms.patientCareplanProblemDTO) => {
    updateCarePlanProblemCache(subForm);
  };

  const deletePlanCache = () => {
    const submissionForm: mumms.patientCareplanProblemDTO = {
      ...patientCareplanProblemDTO,
      status: Discard,
    };

    updateCarePlanProblemCache(submissionForm);
  };

  useEffect(() => {
    if (discardEdit) {
      // close the date picker
      setDateOpen(false);
      // if WIP PLAN and autosaved
      // remaining action in ExpandedCPP.tsx
      if (isEditdata && planCache) {
        deletePlanCache();
      } else {
        dispatch({
          type: DISCARD_EDIT,
          payload: false,
        });
      }
    }
  }, [discardEdit, planCache]);

  /** EFFECTIVE DATE ControlledKeyboardDatePicker */
  const [dateOpen, setDateOpen] = useState<boolean>(false);

  const onOpen = () => {
    setDateOpen(!dateOpen);
  };
  const onClose = () => {
    setDateOpen(false);
  };

  /** handle Date Picker Change */

  const handleEffDateChange = (date: any) => {
    setEffDate(date);
    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState.effectiveDate = date.toString();
    setSubmitButtonState(updatedSubmitButtonState);
    setDateOpen(!dateOpen);
  };

  /** INTERVENTION DATE ControlledKeyboardDatePicker */
  const [intDateOpen, setIntDateOpen] = useState<boolean>(false);

  const onIntOpen = () => {
    setIntDateOpen(!intDateOpen);
  };
  const onIntClose = () => {
    setIntDateOpen(false);
  };

  /** handle Intervention Date Picker Change */

  const handleIntDateChange = (date: any) => {
    setIntDate(date);

    setIntDateOpen(!intDateOpen);
  };

  /** handle Checkbox Change */
  const handleCheckboxChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /**
     * cantUncheck means you need to DC, you can't toggle
     * if the plan has already been submitted and it was checked, you need to DC
     * Need to know the form status (Submitted), the initial state of the form (was checked )
     * and the checkbox state (checked or not)
     */
    const isInitialChecked =
      (initGroupBoxState[parentquestionpath] &&
        initGroupBoxState[parentquestionpath][questionpath]) ||
      false;
    const isChecked =
      (groupBoxState[parentquestionpath] &&
        groupBoxState[parentquestionpath][questionpath]) ||
      false;

    const cantUncheck = isPlanDCable && isInitialChecked && isChecked;

    if (!cantUncheck) {
      onCheckboxChange(event, depthLevel, parentquestionpath, questionpath);
    }
  };

  /** on Checkbox Change */
  const onCheckboxChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      // if you are SELECTING UI
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        // if you are UNSELECTING UI
        updatedArray[depthLevel].splice(index, 1);
        // for all level downs, splice it if includes questionpath
        unselectId(updatedArray, depthLevel, questionpath);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = event.target.checked;
    if (!event.target.checked) {
      // remove children
      cleanSubmittedState(updatedSubmitGroupBoxState, questionpath);
    }
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState[questionpath] = event.target.checked;
    if (!event.target.checked) {
      // remove children
      cleanSubmittedState(updatedSubmitButtonState, questionpath);
    }
    setSubmitButtonState(updatedSubmitButtonState);

    /** update dcGroupBoxState */

    // means we could be UN-DC an item
    // todo need to be able to remove dc date
    if (event.target.checked && dcGroupBoxState[questionpath]) {
      const updatedDcGroupBoxState = {
        ...dcGroupBoxState,
      };

      // remove the DC item from the state
      // logic when saving data to remove dc date and children if event target checked

      delete updatedDcGroupBoxState[questionpath];
      setDCGroupBoxState(updatedDcGroupBoxState);
    }

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    updatedGroupBoxState[parentquestionpath][questionpath] =
      event.target.checked;
    // if you are SELECTING
    if (event.target.checked) {
      updatedGroupBoxState[questionpath] = {};
    } else {
      // if you are UNSELECTING
      // all children are now false
      unselectElement(updatedGroupBoxState, questionpath);
    }

    setGroupBoxState(updatedGroupBoxState);
  };

  /** handleDCdChange */
  const handleDCdChange = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // UPDATE UI AND SUBMIT STATE
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    // will always be the case
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      updatedArray[depthLevel].splice(index, 1);
      // for all level downs, splice it if includes questionpath
      unselectId(updatedArray, depthLevel, questionpath);
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = false;
    // @note special clean submit for DC
    cleanSubmittedStateforDC(updatedSubmitGroupBoxState, questionpath);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    updatedGroupBoxState[parentquestionpath][questionpath] = false;

    // all children are now false
    unselectElement(updatedGroupBoxState, questionpath);

    setGroupBoxState(updatedGroupBoxState);

    // UPDATE DC STATE

    /** update dcGroupBoxState */

    const updatedDcGroupBoxState = {
      ...dcGroupBoxState,
    };
    updatedDcGroupBoxState[questionpath] = true;
    // means all the children items are DC
    setDCGroupBoxState(updatedDcGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState[questionpath] = true;

    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle DC Checkbox Change */
  const handleDCChange = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // race error?
    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    // @note please do not remove
    console.log('handleDCChange', updatedSubmitGroupBoxState[questionpath]);
    // you can DC an item that has been checked
    if (updatedSubmitGroupBoxState[questionpath]) {
      handleDCdChange(depthLevel, parentquestionpath, questionpath);
    }
  };

  /** handle Select Change */
  const handleSelectChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
  ) => {
    const questionpath = event.target.value;
    /** update submitButtonState */
    // @note change an item in multi select should trigger the submit button

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = true;

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    // if nothing selected we can assume updatedGroupBoxState[parentquestionpath] = {}
    // if something already selected => updatedGroupBoxState[parentquestionpath] = {'27571->25005->25609': true}
    const stateArray = Object.keys(updatedGroupBoxState[parentquestionpath]);
    // If something has already been selected
    if (stateArray.length) {
      const key = stateArray[0];
      // remove the previous choice from updatedGroupBoxState
      delete updatedGroupBoxState[key];
      // update the previous choice from updatedSubmitGroupBoxState to false
      // so that the previous choice is being removed
      updatedSubmitGroupBoxState[key] = false;
      // update w current choice
      updatedGroupBoxState[parentquestionpath] = {};
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
      // the submit button should be triggered
      updatedSubmitButtonState[questionpath] = true;
    } else {
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
    }

    setGroupBoxState(updatedGroupBoxState);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Multi Select Change */
  const handleMultiSelectChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
  ) => {
    // if select 2 checkbox
    // event.target.value is  ['27571->25005->25609','27571->25005->25608']
    // if remove 1 checkbox event.target.value is  ['27571->25005->25609']
    // the one removed is not tracked anymore
    // but it needs to be removed from updatedGroupBoxState[questionpath]
    // if stateArray has an element that  event.target.value does not, need to remove it from updatedGroupBoxState
    const questionpaths = event.target.value;
    // TODO UPDATE ALL OTHER STATES

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    /** update submitButtonState */
    // @note change an item in multi select should trigger the submit button

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };

    // if nothing selected we can assume updatedGroupBoxState[parentquestionpath] = {}
    // if something already selected => updatedGroupBoxState[parentquestionpath] = {'27571->25005->25609': true,'27571->25005->25608': true}
    const stateArray = Object.keys(updatedGroupBoxState[parentquestionpath]);
    // stateArray.length should be less than questionpaths.length BUT if an element has been removed

    if (stateArray.length) {
      stateArray.forEach((path: string) => {
        // it means the element has been removed
        if (!questionpaths.includes(path)) {
          // remove the previous choice from updatedGroupBoxState
          delete updatedGroupBoxState[path];
          // update the previous choice from updatedSubmitGroupBoxState to false
          // so that the previous choice is being removed
          updatedSubmitGroupBoxState[path] = false;
          // the submit button should be triggered
          updatedSubmitButtonState[path] = true;
        }
      });
    }

    // reset GROUP BOX STATE
    updatedGroupBoxState[parentquestionpath] = {};

    // update the updatedGroupBoxState
    questionpaths.forEach((path: string) => {
      updatedGroupBoxState[parentquestionpath][path] = true;
      updatedGroupBoxState[path] = {};
    });

    // update the updatedSubmitGroupBoxState
    questionpaths.forEach((path: string) => {
      if (!stateArray.includes(path)) {
        // then update with new selected element
        updatedSubmitGroupBoxState[path] = true;
        // the submit button should be triggered
        updatedSubmitButtonState[path] = true;
      }
    });

    setGroupBoxState(updatedGroupBoxState);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    setSubmitButtonState(updatedSubmitButtonState);
  };

  // todo add it?
  const handleRadioUpdate = (
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // check if this radio was previously selected
    // if yes this is because it was clicked off and clicked on again
    // losing the past history
    if (initGroupBoxState[parentquestionpath][questionpath]) {
      // was selected before
      // need to reconstruct the structure
      if (
        initGroupBoxState[questionpath] &&
        Object.keys(initGroupBoxState[questionpath])
      ) {
        // step 1
        const updatedGroupBoxState = {
          ...groupBoxState,
        };
        updatedGroupBoxState[questionpath] = cloneDeep(
          initGroupBoxState[questionpath],
        );
        // step 2
        Object.keys(initGroupBoxState[questionpath]).forEach((key: string) => {
          updatedGroupBoxState[key] = {};
        });
        setGroupBoxState(updatedGroupBoxState);

        // step 3
        const updatedSubmitGroupBoxState = {
          ...submitGroupBoxState,
        };
        Object.keys(initGroupBoxState[questionpath]).forEach((key: string) => {
          updatedSubmitGroupBoxState[key] = true;
        });
        setSubmitGroupBoxState(updatedSubmitGroupBoxState);
      }
    }
  };

  /** handle Radio Change */
  const handleRadioChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /** get all Radio Elements */

    const radioParent = getRadioParent(updatedData, parentquestionpath);
    const radioChildren = radioParent.subqchoices
      .filter((item: any) => item.controltype === 'radio')
      .map((item: any) => item.questionpath);
    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    // is any of the radio selected
    let radioSelectedPath: string | null = null;
    radioChildren.forEach((path: string) => {
      if (
        updatedGroupBoxState[parentquestionpath][path] &&
        updatedGroupBoxState[path]
      ) {
        radioSelectedPath = path;
      }
      return null;
    });

    if (radioSelectedPath) {
      // if a radio child is already selected need to unselect it
      updatedGroupBoxState[parentquestionpath][radioSelectedPath] = false;
      unselectElement(updatedGroupBoxState, radioSelectedPath);
      // then check the one that has been clicked
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
    } else {
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
    }

    /** update RADIO groupBoxState */

    setGroupBoxState(updatedGroupBoxState);

    /** update selectedIds */

    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      // if a radio child is already selected need to unselect it
      if (radioSelectedPath) {
        const index = updatedArray[depthLevel].indexOf(radioSelectedPath);
        updatedArray[depthLevel].splice(index, 1);
        // for all level downs, splice it if includes questionpath
        unselectId(updatedArray, depthLevel, radioSelectedPath);
      }
      // add it
      updatedArray[depthLevel].push(questionpath);
    } else {
      updatedArray[depthLevel] = [questionpath];
    }

    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (radioSelectedPath) {
      updatedSubmitGroupBoxState[radioSelectedPath] = false;
      cleanSubmittedState(updatedSubmitGroupBoxState, radioSelectedPath);
    }
    updatedSubmitGroupBoxState[questionpath] = true;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update dcGroupBoxState */

    // means we could be UN-DC an item
    // todo need to be able to remove dc date
    if (event.target.checked && dcGroupBoxState[questionpath]) {
      const updatedDcGroupBoxState = {
        ...dcGroupBoxState,
      };

      // remove the DC item from the state
      // logic when saving data to remove dc date and children if event target checked

      delete updatedDcGroupBoxState[questionpath];
      setDCGroupBoxState(updatedDcGroupBoxState);
    }

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState[questionpath] = true;

    setSubmitButtonState(updatedSubmitButtonState);

    /** handleRadioUpdate submitButtonState */

    // handleRadioUpdate(parentquestionpath, questionpath);
  };

  /** handle Input Change */

  const handleInputChange = (
    inputValue: string,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /** clean up the string */
    const textValue = getInputEngine(inputValue);

    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      // if you are SELECTING
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        // if you are UNSELECTING
        updatedArray[depthLevel].splice(index, 1);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    updatedSubmitGroupBoxState[questionpath] = textValue;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    if (!updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath] = {};
    }
    updatedGroupBoxState[parentquestionpath][questionpath] = textValue;
    // // if you are SELECTING

    setGroupBoxState(updatedGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    // the submit button should be triggered
    updatedSubmitButtonState[questionpath] = true;
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Comment Change */

  const handleCommentChange = (value: string, subqchoice: any) => {
    const textValue = value;
    const otherInput = getOtherOption(subqchoice);
    const { parentquestionpath, questionpath } = otherInput;

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    if (!updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath] = {};
    }
    updatedGroupBoxState[parentquestionpath][questionpath] = textValue;
    // // if you are SELECTING

    setGroupBoxState(updatedGroupBoxState);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    updatedSubmitGroupBoxState[questionpath] = textValue;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    // the submit button should be triggered
    updatedSubmitButtonState[questionpath] = true;
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /**
   * handle Label Change
   */

  const handleLabelChange = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    const checked = true;
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        updatedArray[depthLevel].splice(index, 1);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    updatedSubmitGroupBoxState[questionpath] = checked;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    if (!updatedGroupBoxState[parentquestionpath][questionpath]) {
      updatedGroupBoxState[parentquestionpath][questionpath] = checked;
      if (checked) {
        updatedGroupBoxState[questionpath] = {};
      } else {
        // all children are now false
        updatedGroupBoxState[questionpath] = mapValues(
          updatedGroupBoxState[questionpath],
          () => false,
        );
      }

      setGroupBoxState(updatedGroupBoxState);
    }
  };

  const autoUnroll = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // avoid multiple renders
    if (!groupBoxState[parentquestionpath]) {
      groupBoxState[parentquestionpath] = {};
    }
    if (!groupBoxState[parentquestionpath][questionpath]) {
      const checked = true;
      /** update selectedIds */
      const updatedArray = [...selectedIds];
      if (updatedArray[depthLevel]) {
        const index = updatedArray[depthLevel].indexOf(questionpath);
        if (index === -1) {
          updatedArray[depthLevel].push(questionpath);
        } else {
          updatedArray[depthLevel].splice(index, 1);
        }
      } else {
        updatedArray[depthLevel] = [questionpath];
      }
      setSelectedIds(updatedArray);

      /** update groupBoxState */

      const updatedGroupBoxState = {
        ...groupBoxState,
      };

      const childrenPaths = Object.keys(
        updatedGroupBoxState[parentquestionpath],
      );

      if (!updatedGroupBoxState[parentquestionpath][questionpath]) {
        updatedGroupBoxState[questionpath] = {};
        updatedGroupBoxState[parentquestionpath][questionpath] = checked;

        childrenPaths.forEach((path) => {
          if (!updatedGroupBoxState[path]) {
            updatedGroupBoxState[path] = {};
          }
        });

        setGroupBoxState(updatedGroupBoxState);
      }

      /** update submitGroupBoxState */

      const updatedSubmitGroupBoxState = {
        ...submitGroupBoxState,
      };
      updatedSubmitGroupBoxState[questionpath] = checked;

      childrenPaths.forEach((path) => {
        if (!updatedSubmitGroupBoxState[path]) {
          updatedSubmitGroupBoxState[path] = checked;
        }
      });

      setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    }
  };

  /**
   * onSubmit
   */
  const isEditing = formData.type === Editing || formData.type === EditFullMode;
  const onSubmit = async () => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;

    if (isPlanTitleEditable) {
      if (isOtherPlanNoTitle) {
        setErrorInfo({
          text: defaults.otherTitleError,
          severity: 'error',
        });
        resetSubmitPlan();
        return;
      }
    }
    if (submitPlan?.status === Submitted) {
      // effective date filled
      if (effDate) {
        if (isEditing) {
          /**
           * Submit a Form that is in Edit Mode => present the user with the diff
           */
          resetSubmitInProgress();
          onCheckDiff();
          // alert TaskPlanner to be in preview mode
          dispatch({
            type: SET_PREVIEW_MODE,
            payload: true,
          });
        } else {
          await submitForm();
        }
      } else {
        // open the date picker
        setDateOpen(true);
        setErrorInfo({
          text: defaults.effDate,
          severity: 'error',
        });
        resetSubmitPlan();
      }
    } else {
      await submitForm();
    }
  };

  /**
   * onCheckDiff to generate DIFF state
   */
  const onCheckDiff = async () => {
    const submitStateCopy = cloneDeep(submitGroupBoxState);
    const diffSubmitState = createPreviewState(
      initSubmitGroupBoxState,
      submitStateCopy,
    );
    const diffSubmitStateCopy = cloneDeep(diffSubmitState);

    let dcState = null;
    const dcActualState = cloneDeep(dcGroupBoxState);
    // if dcGroupBoxState create a diff DC state
    if (Object.keys(dcGroupBoxState).length) {
      dcState = createDCState(initDCGroupBoxState, dcActualState);
    }

    const entireDcState = dcState
      ? createPreviewDCState(initDCGroupBoxState, dcActualState)
      : {};
    const diffState = {
      ...diffSubmitStateCopy,
      ...entireDcState,
    };
    getDiffData(diffState, dcState);
  };

  /**
   * generate diff data to generate diff preview form
   */
  const getDiffData = (
    diffstate: Record<string, any>,
    dcstate: Record<string, any> | null,
  ) => {
    const blankdata = cloneDeep(updatedData);
    // ****  step 1 is create a blank new data form ****
    const newData = reinstateForm(blankdata);
    // **** step 2 is to update the form with the diff state ****
    let answeredDiffData = cloneDeep(newData);
    // **** Update answers ****
    // for each key in diffState, find it in data and update value of items
    Object.keys(diffstate).forEach((key) => {
      answeredDiffData = updateElementBis(answeredDiffData, key, diffstate);
    });
    // **** DC items *****
    // for each key in dcState, find it in updatedData and update dcdate
    if (dcstate) {
      Object.keys(dcstate).forEach((key) => {
        answeredDiffData = updateDCElement(
          answeredDiffData,
          key,
          formatPostDate(Date.now()),
        );
      });
    }
    setPreviewData(answeredDiffData);
  };
  /**
   * Preview Form Actions
   */
  const onOKPreviewClick = () => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;
    setPreviewSubmitDisabled(true);
    submitForm();
    setTimeout(() => {
      dispatch({
        type: RESET_DISCARD_EDIT,
        payload: true,
      });
    }, 1000);
  };
  /**
   * Preview Form Actions
   */
  const onCancelPreviewClick = () => {
    setSelectedIds(initIds);
    setGroupBoxState(initGroupBoxState);
    setSubmitGroupBoxState(initSubmitGroupBoxState);
    setSubmitButtonState({});
    setDCGroupBoxState(initDCGroupBoxState);
    setPreviewData(null);
    // delete the cached data
    if (isEditdata && planCache) {
      deletePlanCache();
    }
    resetSubmitPlan();
    dispatch({
      type: RESET_DISCARD_EDIT,
      payload: true,
    });
    // task planner in edit mode
    dispatch({
      type: SET_PREVIEW_MODE,
      payload: false,
    });
  };

  /**
   * generate data to be saved through recursion
   */
  const getPlanData = () => {
    const isSubmittable =
      submitGroupBoxState && Object.keys(submitGroupBoxState).length;
    if (isSubmittable) {
      // updatedData still has true and dc not here anymore
      // problem if you undo DC and something already selected before
      let newData = cloneDeep(updatedData);
      // **** Update answers ****
      // for each key in submitGroupBoxState, find it in updatedData and update value of items
      Object.keys(submitGroupBoxState).forEach((key) => {
        newData = updateElementBis(newData, key, submitGroupBoxState);
      });
      // update children to false if parent element is false- EDIT version
      newData = updateFalseNodes(newData);

      // **** DC items *****
      // for each key in dcGroupBoxState, find it in updatedData and update dcdate
      Object.keys(dcGroupBoxState).forEach((key) => {
        newData = updateDCElement(newData, key, formatPostDate(Date.now()));
      });
      newData = updateChildDCNodes(newData, formatPostDate(Date.now()));
      // Add Effdate to edited elements

      const stringifyData = JSON.stringify(newData);
      return stringifyData;
    }
    return null;
  };

  const submitForm = async () => {
    setIsLoading(true);

    try {
      const formsubmission = getPlanData();
      if (formsubmission) {
        const status = submitPlan ? submitPlan.status : Submitted;
        const { type } = formData;

        const submissionPlan: mumms.patientCareplanProblemDTO = {
          ...patientCareplanProblemDTO,
          formsubmission,
          status,
        };

        await savePatientCarePlanProblem(
          patient.patientNumber,
          submissionPlan,
          status,
          type,
        );

        dispatch({
          type: SET_CPP,
          payload: null,
        });

        dispatch({
          type: SET_CPP_TASKS,
          payload: null,
        });

        resetSubmitPlan();
      }
    } finally {
      setIsLoading(false);
      resetSubmitInProgress();
    }
  };

  const resetSubmitPlan = () => {
    // reset submit form to false
    dispatch({
      type: SUBMIT_PLAN,
      payload: null,
    });
    // reset submit form button to false
    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: false,
    });
    dispatch({
      type: SET_PREVIEW_MODE,
      payload: false,
    });
    resetSubmitInProgress();
  };

  const getDCButton = (subqchoice: any, depthLevel: any) => {
    // isDCDisabled is active if the plan had been submitted and it is initially checked
    let isDCDisabled;
    const isPlanCurrentlyDc = subqchoice.dcdate;
    // plan is In Progress or not yet submitted
    if (!isPlanDCable) {
      isDCDisabled = true;
    } else if (isPlanCurrentlyDc) {
      isDCDisabled = true;
    } else {
      const isInitialChecked =
        (initGroupBoxState[subqchoice.parentquestionpath] &&
          initGroupBoxState[subqchoice.parentquestionpath][
            subqchoice.questionpath
          ]) ||
        false;
      if (isInitialChecked) {
        isDCDisabled = !!dcGroupBoxState[subqchoice.questionpath];
      } else {
        isDCDisabled = true;
      }
    }

    return (
      subqchoice.isdcable && (
        <DCButton
          radio
          key={`field-${subqchoice.id}`}
          disabled={isDCDisabled}
          handleChange={() => {
            handleDCChange(
              depthLevel,
              subqchoice.parentquestionpath,
              subqchoice.questionpath,
            );
          }}
        />
      )
    );
  };

  const renderField = (
    subqchoice: any,
    depthLevel: any,
    subMenu: any,
    // eslint-disable-next-line consistent-return
  ) => {
    switch (subqchoice.controltype) {
      // label cannot be DC
      case label:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-label">
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-label"
              horizontal={subqchoice.drawmode === horizontal}
            >
              <LabelField
                key={`field-${subqchoice.id}`}
                text={subqchoice.questionlabel}
                isExpanded={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ]) ||
                  false
                }
                onClick={() => {
                  handleLabelChange(
                    depthLevel,
                    subqchoice.parentquestionpath,
                    subqchoice.questionpath,
                  );
                }}
              />
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
      // INPUT cannot be DC
      case input:
        // @note subqchoice.isothercomment => to not get input component 2 times with the one from Other dropdown
        return subqchoice.isothercomment ? null : (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <InputField
                key={`field-${subqchoice.id}`}
                // todo label or parentpatientlabel
                label={subqchoice.questionlabel}
                subqchoice={subqchoice}
                value={
                  groupBoxState[subqchoice.parentquestionpath] &&
                  groupBoxState[subqchoice.parentquestionpath][
                    subqchoice.questionpath
                  ]
                    ? groupBoxState[subqchoice.parentquestionpath][
                        subqchoice.questionpath
                      ]
                    : ''
                }
                handleChange={(event: any) => {
                  handleInputChange(
                    event,
                    depthLevel,
                    subqchoice.parentquestionpath,
                    subqchoice.questionpath,
                  );
                }}
              />
              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      case radio:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <RadioField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ]) ||
                  false
                }
                handleChange={(event: any) => {
                  handleRadioChange(
                    event,
                    depthLevel,
                    subqchoice.parentquestionpath,
                    subqchoice.questionpath,
                  );
                }}
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      // single select cannot be DC
      case singleselect:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <SelectField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ] &&
                    groupBoxState[subqchoice.questionpath]) ||
                  {}
                }
                state={groupBoxState}
                handleChange={(event: any) => {
                  handleSelectChange(
                    event,
                    depthLevel,
                    subqchoice.questionpath,
                  );
                }}
                handleCommentChange={(value: string) => {
                  handleCommentChange(value, subqchoice);
                }}
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      // multi select cannot be DC
      case multiselect:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <MultiSelectField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ] &&
                    groupBoxState[subqchoice.questionpath]) ||
                  {}
                }
                state={groupBoxState}
                handleChange={(event: any) => {
                  handleMultiSelectChange(
                    event,
                    depthLevel,
                    subqchoice.questionpath,
                  );
                }}
                handleCommentChange={(value: string) => {
                  handleCommentChange(value, subqchoice);
                }}
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      // case null and checkbox:
      default:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-checkbox">
            {getDCButton(subqchoice, depthLevel)}
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <CheckBoxField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ]) ||
                  false
                }
                handleChange={(event: any) => {
                  handleCheckboxChange(
                    event,
                    depthLevel,
                    subqchoice.parentquestionpath,
                    subqchoice.questionpath,
                  );
                }}
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
    }
  };

  const renderSubMenu = (
    subqchoices: any,
    depthLevel = 0,
    isHorizontal?: boolean,
  ) => {
    const menuOptions = subqchoices.map((subqchoice: any) => {
      const hasOptions = checkSubqchoices(subqchoice);

      // isHorizontalMode should be for input/singleselect/multiselect

      // Forms that do not follow this pattern are
      // **ALTERATION IN NEURO**
      // **SPIRITUAL DISCOMFORT**
      // **SAFETY/SELF CARE DEFICIT**
      const isHorizontalMode = subqchoice.drawmode === horizontal;

      let subMenu;

      // auto_unroll to unroll
      // the option is not clicked so no handleChange function => autoUnroll
      if (subqchoice.autounroll) {
        const { parentquestionpath, questionpath } = subqchoice;

        const newDepthLevel = depthLevel + 1;
        autoUnroll(newDepthLevel, parentquestionpath, questionpath);

        subMenu = renderSubMenu(
          subqchoice.subqchoices,
          newDepthLevel,
          isHorizontalMode,
        );
      }

      // only render selected submenu and only if nested options exist

      if (
        groupBoxState &&
        selectedIds &&
        selectedIds[depthLevel] &&
        selectedIds[depthLevel].indexOf(subqchoice.questionpath) > -1 &&
        groupBoxState[subqchoice.parentquestionpath] &&
        groupBoxState[subqchoice.parentquestionpath][subqchoice.questionpath] &&
        hasOptions
      ) {
        const newDepthLevel = depthLevel + 1;

        subMenu = renderSubMenu(
          subqchoice.subqchoices,
          newDepthLevel,
          isHorizontalMode,
        );
      }

      return renderField(subqchoice, depthLevel, subMenu);
    });

    return (
      <div key={`div-key-${depthLevel}`} id="cpp-high">
        {/* <FormLabel component="legend">Related to</FormLabel> */}
        <div id="cpp-low">
          <StyledUl className="cpp-ul" horizontal={isHorizontal}>
            {menuOptions}
          </StyledUl>
        </div>
        {/* <FormHelperText>You can display an error</FormHelperText> */}
      </div>
    );
  };

  const PlanTitle = (
    <Typography variant="body1" className={classes.boldTitle}>
      {formData && (formData as any)?.careplanproblemname}
    </Typography>
  );

  const getCPPTitle = () => (
    <CPPTitleInputField
      value={cppTitle}
      handleTitleChange={handleTitleChange}
    />
  );

  const getDatePicker = () => (
    <EffDateDiv>
      <FormHelperText id="component-helper-text">
        {defaults.effDate}
      </FormHelperText>
      <ReactDatePicker
        selectedDate={effDate}
        onChange={handleEffDateChange}
        maximumDate={new Date()}
        minimumDate={basicDateConstraint}
        open={dateOpen}
        onCalendarOpen={onOpen}
        onCalendarClose={onClose}
      />
    </EffDateDiv>
  );

  const getInterventionDatePicker = () => (
    <EffDateDiv>
      <FormHelperText id="component-helper-text">
        {defaults.intDate}
      </FormHelperText>
      <ReactDatePicker
        selectedDate={intDate}
        onChange={handleIntDateChange}
        maximumDate={new Date()}
        minimumDate={effDate}
        open={intDateOpen}
        onCalendarOpen={onIntOpen}
        onCalendarClose={onIntClose}
      />
    </EffDateDiv>
  );

  const getFormRecursively = () =>
    isPlanValid ? (
      groupBoxState &&
      Object.keys(groupBoxState)[0] === Object.keys(initGroupBoxState)[0] &&
      renderSubMenu(updatedData) && <>{renderSubMenu(updatedData)}</>
    ) : (
      <div>{defaults.errorDisplay}</div>
    );

  const getFormRendering = () => (
    <FormBody id="form-renderer">
      {getDatePicker()}
      {isEditing && !isAddAssistancePlan && getInterventionDatePicker()}
      {isPlanTitleEditable && getCPPTitle()}
      {PlanTitle}
      {getFormRecursively()}
    </FormBody>
  );

  const getReadOnlyForm = () => (
    <ReadOnlyForm
      formData={savedCarePlanProblem}
      pnNotes={cppNotesGlobal && cppNotesGlobal[formData.id]}
    />
  );

  const getPreviewForm = () => (
    <PreviewFormDiv>
      <ScrollToTarget />
      <PreviewFormTop />
      <PreviewForm
        onOKPreviewClick={onOKPreviewClick}
        onCancelPreviewClick={onCancelPreviewClick}
        okDisabled={previewSubmitDisabled}
      />
      <ReadOnlyForm formData={previewData} previewData />
    </PreviewFormDiv>
  );

  const getFormUI = () => {
    if (previewData) {
      return getPreviewForm();
    } else if (savedCarePlanProblem) {
      return getReadOnlyForm();
    }
    return getFormRendering();
  };

  return (
    <Fragment>
      {isLoading && <Loader />}
      {isLoading && !isEditing && (
        <SavingDiv id="saving-form">{defaults.saving}</SavingDiv>
      )}
      {getFormUI()}
    </Fragment>
  );
});

export default FormRenderer;
